import React, { useRef, useState, useContext, useEffect } from "react";
import { IoMdArrowUp } from "react-icons/io";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { DContext } from "../../../../../context/Datacontext";
import { apiFetch } from "../../../../services/fetchApi";

export const Resume = ({ userId, applicantID = "", _id, resumeAvailable, resumeLink, applicantName, experience = { month: 0, year: 0 }, submitData, candidate,setCandidate }) => {
  const { BeURL, showAlert } = useContext(DContext);
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState("");
  const [fileURL, setFileURL] = useState("");
  const [progress, setProgress] = useState(0);
  const [parsedText, setParsedText] = useState("");
  const [loading, setLoading] = useState(false);
  const [displayFilename, setDisplayFilename] = useState("");
  const [endpoint, setEndpoint] = useState(null);
  const [loadingView, setLoadingView] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);

  const tempApplicantFullName = applicantName ? applicantName : "Candidate"

  console.log("candidate", candidate)

  // build the base name once:
  const safeName = (tempApplicantFullName).replace(
    /[<>:"/\\|?*.]/g,
    ""
  );
  const expLabel =
    experience.year || experience.month
      ? `[${experience.year || 0}y ${experience.month || 0}m]`
      : "[_Resume]";
  const baseName = `SAN_${safeName}${expLabel}`;

  useEffect(() => {
    if (BeURL && (applicantID || _id)) {
      setEndpoint(`${BeURL}/resume/${_id || applicantID}`);
      if (resumeAvailable && resumeLink) {
        const extMatch = resumeLink.match(/\.(\w+)$/);
        const ext = extMatch ? `.${extMatch[1]}` : ".pdf";
        setDisplayFilename(`${baseName}${ext}`);
      } else {
        setDisplayFilename(`${baseName}.pdf`);
      }
    }
  }, [BeURL, applicantID, _id, resumeAvailable, resumeLink]);

  const handleClick = () => fileInputRef.current.click();

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // File size check
    if (file.size > 5 * 1024 * 1024) {
      alert("File size exceeds 5MB.");
      return;
    }

    setFileName(file.name);

    // Blob preview
    const url = URL.createObjectURL(file);
    setFileURL(url);

    // Upload with progress
    const formData = new FormData();
    formData.append("resume", file);

    try {
      setLoading(true); // ⬅️ start loading
      const res = await apiFetch(`${BeURL}/upload?id=${_id}`, {
        // credentials: 'include',
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      if (data.success) {
        showAlert(data.message);
        setCandidate(data.candidate)
    
      } else {
        showAlert(data.message);
      }
    } catch (err) {
      console.error("Upload error:", err);
      showAlert("Error uploading resume.");
    } finally {
      setLoading(false); // ⬅️ stop loading
    }
  };

  // View inline if PDF, otherwise download
  const handleView = async () => {
    if (loadingView) return;
    setLoadingView(true);
    try {
      const res = await apiFetch(`${endpoint}?download=0`, {
        credentials: "include"
      });
      if (!res.ok) throw new Error(`Server ${res.status}`);

      const contentType = res.headers.get("content-type") || "";
      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);

      if (contentType.includes("pdf")) {
        window.open(blobUrl, "_blank");
      } else {
        // fallback: directly download non-PDFs
        const cd = res.headers.get("content-disposition") || "";
        const fnMatch = cd.match(/filename\*?=?[^']*'?'?([^;"]+)/i);
        const filename = fnMatch
          ? decodeURIComponent(fnMatch[1])
          : displayFilename;
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }

      setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
    } catch (err) {
      console.error("View failed:", err);
      alert("Could not load resume for viewing.");
    } finally {
      setLoadingView(false);
    }
  };

  // Always download, using server-sent filename
  const handleDownload = async () => {
    if (loadingDownload) return;
    setLoadingDownload(true);
    try {
      const res = await apiFetch(`${endpoint}?download=1`, {

      });
      if (!res.ok) throw new Error(`Server ${res.status}`);

      const blob = await res.blob();
      const cd = res.headers.get("content-disposition") || "";
      const fnStar = cd.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
      const fnQuoted = cd.match(/filename\s*=\s*"([^"]+)"/i);
      const fnUnquoted = cd.match(/filename\s*=\s*([^;]+)/i);
      let filename;
      if (fnStar) filename = decodeURIComponent(fnStar[1]);
      else if (fnQuoted) filename = fnQuoted[1];
      else if (fnUnquoted) filename = fnUnquoted[1].trim();
      else filename = displayFilename;

      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
    } catch (err) {
      console.error("Download failed:", err);
      alert("Could not download resume.");
    } finally {
      setLoadingDownload(false);
    }
  };

  return (
    <div className="w-full grid gap-5">
      <p>
        Resume <span className="text-red-500">*</span>
      </p>

      <div className="w-full bg-white border rounded-xl p-6 flex flex-col justify-center items-center text-center">
        <h3 className="text-lg font-semibold">
          Upload Your Resume <span className="text-red-500">*</span>
        </h3>
        <p className="text-gray-600 mb-4">
          Let employers access your full professional profile.
        </p>

        <div
          onClick={handleClick}
          className="cursor-pointer border-2 border-dashed border-blue-500 p-6 rounded-md flex flex-col items-center w-full max-w-md hover:bg-blue-50"
        >
          <IoMdArrowUp className="h-10 w-10 text-blue-600 mb-2" />
          <p className="text-blue-600 underline">
            {fileName ? fileName : "Click here to upload resume"}
          </p>
        </div>

        <input
          type="file"
          ref={fileInputRef}
          className="hidden"
          onChange={handleFileChange}
          accept=".pdf,.doc,.docx"
        />

        {/* Loading spinner */}
        {loading && (
          <div className="flex items-center mt-3 space-x-2">
            <AiOutlineLoading3Quarters className="animate-spin text-blue-600 text-2xl" />
            <p className="text-blue-600 font-semibold">Uploading...</p>
          </div>
        )}

        {/* File preview */}
        <div className="mt-3">
          <span
            onClick={(displayFilename || "").endsWith(".pdf") ? handleView : handleDownload}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            {
              (loadingView || loadingDownload) &&
              <span className="inline-block ml-1">
                <span className="dot bounce delay-0 bg-primary-300"></span>
                <span className="dot bounce delay-1 bg-secondary-300"></span>
                <span className="dot bounce delay-2 bg-slate-800"></span>
              </span>}
            Preview Resume {Boolean(resumeAvailable && resumeLink) && (` - ${displayFilename || ""}`)}
          </span>
        </div>

        <p className="text-sm text-gray-500 mt-2">
          Supported formats: pdf, doc, docx | Max size: 5MB
        </p>

        {/* Parsed resume text */}
        {parsedText && (
          <div className="mt-4 p-4 border rounded bg-gray-100 w-full text-left">
            <h4 className="font-semibold">Parsed Resume Text (ATS):</h4>
            <p className="text-sm">{parsedText}</p>
          </div>
        )}
      </div>
    </div>
  );
};
